{
  "actionbar.actions": "Toimingud",
  "actionbar.actionsAvailable": "Toimingud saadaval.",
  "actionbar.clearSelection": "Puhasta valik",
  "actionbar.selected": "{count, plural, =0 {Pole valitud} other {# valitud}}",
  "actionbar.selectedAll": "Kõik valitud",
  "breadcrumbs.more": "Veel üksusi",
  "button.pending": "ootel",
  "combobox.noResults": "Tulemusi pole",
  "contextualhelp.help": "Spikker",
  "contextualhelp.info": "Teave",
  "dialog.alert": "Teade",
  "dialog.dismiss": "Lõpeta",
  "dropzone.replaceMessage": "Kukuta fail asendamiseks",
  "inlinealert.informative": "Teave",
  "inlinealert.negative": "Viga",
  "inlinealert.notice": "Hoiatus",
  "inlinealert.positive": "Valmis",
  "label.(optional)": "(valikuline)",
  "label.(required)": "(nõutav)",
  "menu.moreActions": "Veel toiminguid",
  "notificationbadge.indicatorOnly": "Uus tegevus",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Valige…",
  "slider.maximum": "Maksimaalne",
  "slider.minimum": "Minimaalne",
  "table.loading": "Laadimine...",
  "table.loadingMore": "Laadi rohkem...",
  "table.resizeColumn": "Muuda veeru suurust",
  "table.sortAscending": "Sordi kasvavalt",
  "table.sortDescending": "Sordi kahanevalt",
  "tag.actions": "Toimingud",
  "tag.hideButtonLabel": "Kuva vähem",
  "tag.noTags": "Puudub",
  "tag.showAllButtonLabel": "Kuva kõik ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
